// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Products_SetPrimaryImageResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for POST /so/products/setPrimaryImage
 *
 * Confirms which image is now primary. The controller has already
 * cleared `is_primary` on all sibling rows inside a transaction.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Products_SetPrimaryImageResponseDados {
so_product_image_id: number
}

export type Products_SetPrimaryImageResponse = ApiResponse<Products_SetPrimaryImageResponseDados>;

registerResponseContract('Products_SetPrimaryImageResponse', {
  so_product_image_id: { type: 'number',  required: true },
})
